import { render, staticRenderFns } from "./DetaiAssessLanguageCertificate.vue?vue&type=template&id=37689e6d&"
import script from "./DetaiAssessLanguageCertificate.vue?vue&type=script&lang=js&"
export * from "./DetaiAssessLanguageCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports